// @flow

// Selectors
import { fields$ } from 'fc-assets'
import { crops$ } from 'fc-model-crops'
import { jobs$ } from 'hfty-soil-jobs'
import commentsFilteredByField$ from './selectors/commentsFilteredByField'
import { currentUserUnits$ } from 'hfty-users'

import tableState$ from './selectors/tableState'

// DataTable Compose
import composeCommentDataTable from 'hfty-datatable-comments'

export default composeCommentDataTable({
  comments$: commentsFilteredByField$,
  fields$,
  crops$,
  jobs$,
  tableState$,
  currentUserUnits$,
})
